import { Component, computed, input } from '@angular/core';

import { CmsTeaser } from '@fcom/core-api';

import { toLinkData } from '../../services/template/data-mappers';

@Component({
  selector: 'cms-cta-link',
  template: `
    <fin-cta-big-link
      [target]="cmsTarget()"
      [teaserTitle]="content().teaserTitle"
      [teaserText]="content().teaserText"
      [layout]="'small'"
      class="mr-small-t mr-xxsmall-b"
    />
  `,
  standalone: false,
})
export class CmsCtaLinkComponent {
  content = input.required<CmsTeaser>();

  cmsTarget = computed(() => {
    return toLinkData(this.content().target);
  });
}
